import { ShieldCheck, Upload } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import TermsContent from "@/components/TermsContent";
import { t } from "@/lib/i18n";

export function CountryCurrency({ meta, form, setForm }) {
  const onCountry = (e) => {
    const c = meta.countries.find((x) => x.name === e.target.value);
    setForm({ ...form, country: e.target.value, currency: c ? c.currency : form.currency });
  };
  return (
    <div className="grid sm:grid-cols-2 gap-4">
      <div>
        <label className="hf-label">{t("Country of operation")}</label>
        <select required value={form.country || ""} onChange={onCountry} className="hf-input" data-testid="register-country-select">
          <option value="">{t("Select country…")}</option>
          {meta.countries.map((c) => <option key={c.name}>{c.name}</option>)}
        </select>
      </div>
      <div>
        <label className="hf-label">{t("Currency you trade in")}</label>
        <select required value={form.currency || ""} onChange={(e) => setForm({ ...form, currency: e.target.value })} className="hf-input" data-testid="register-currency-select">
          <option value="">{t("Select currency…")}</option>
          {meta.currencies.map((c) => <option key={c} value={c}>{c} — {meta.currency_names?.[c] || c}</option>)}
        </select>
      </div>
    </div>
  );
}

export function GitSection({ form, setForm, file, setFile }) {
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const today = new Date().toISOString().slice(0, 10);
  return (
    <div className="rounded-lg border-2 border-amber-300 bg-amber-50/40 p-5 space-y-4" data-testid="register-git-section">
      <div>
        <p className="flex items-center gap-2 font-display font-bold"><ShieldCheck className="w-4 h-4 text-amber-600" /> {t("Goods in Transit (GIT) insurance")}</p>
        <p className="text-xs text-slate-600 mt-1">{t("Required for all transporters. Shippers see these details once a bid is confirmed.")}</p>
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <div><label className="hf-label">{t("Insurer")}</label><input required value={form.git_insurer || ""} onChange={set("git_insurer")} className="hf-input" data-testid="register-git-insurer-input" /></div>
        <div><label className="hf-label">{t("Policy number")}</label><input required value={form.git_policy_number || ""} onChange={set("git_policy_number")} className="hf-input" data-testid="register-git-policy-input" /></div>
        <div><label className="hf-label">{t("Cover amount per load")} {form.currency ? `(${form.currency})` : ""}</label><input required type="number" min="1" value={form.git_cover_amount || ""} onChange={set("git_cover_amount")} className="hf-input" data-testid="register-git-cover-input" /></div>
        <div><label className="hf-label">{t("Policy expiry date")}</label><input required type="date" min={today} value={form.git_expiry_date || ""} onChange={set("git_expiry_date")} className="hf-input" data-testid="register-git-expiry-input" /></div>
      </div>
      <label className={`flex items-center gap-3 p-3 rounded-md border border-dashed cursor-pointer bg-white ${file ? "border-emerald-400" : "border-slate-300 hover:border-amber-500"}`}>
        <Upload className="w-4 h-4 text-slate-500" />
        <span className="min-w-0 flex-1">
          <span className="block text-sm font-semibold">{t("GIT insurance certificate *")}</span>
          <span className="block text-xs text-slate-500 truncate">{file ? file.name : t("PDF, JPG or PNG · max 10MB")}</span>
        </span>
        <input type="file" accept=".pdf,.png,.jpg,.jpeg,.webp" className="hidden" data-testid="register-git-doc-input" onChange={(e) => setFile(e.target.files[0] || null)} />
      </label>
    </div>
  );
}

export function TermsCheckbox({ checked, onChange }) {
  return (
    <div className="flex items-start gap-3 p-4 rounded-md border border-slate-200 bg-slate-50">
      <input id="terms" type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-1 w-4 h-4 accent-amber-600" data-testid="register-terms-checkbox" />
      <label htmlFor="terms" className="text-sm text-slate-700">
        I have read and agree to the{" "}
        <Dialog>
          <DialogTrigger asChild>
            <button type="button" className="text-amber-700 font-semibold underline" data-testid="open-terms-btn">{t("Terms & Conditions and Privacy Policy")}</button>
          </DialogTrigger>
          <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="terms-dialog">
            <DialogHeader><DialogTitle>{t("Terms & Conditions and Privacy Policy")}</DialogTitle></DialogHeader>
            <TermsContent />
          </DialogContent>
        </Dialog>
        {t(", and I consent, under the data-protection laws that apply to me (such as POPIA or GDPR), to Mi-Load processing my information and sharing my contact details and registration papers with the other party once a bid is confirmed.")}
      </label>
    </div>
  );
}
